import React, { Dispatch } from 'react'

import { connect } from 'react-redux'
import { IReduxAction } from '../../../utils/ReduxStore'
import IconLabel from '../../Helpers/IconLabel'

interface IDispatchProps {
  reset: () => void
}

interface IProps extends IDispatchProps {}

class ResetButton extends React.Component<IProps> {
  public render(): JSX.Element {
    return (
      <button
        className="btn btn-outline-danger Reset w-100"
        onClick={this.props.reset}
      >
        <IconLabel icon="fas fa-undo" label="Reset" />
      </button>
    )
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IReduxAction>
): IDispatchProps => ({
  reset: (): void => {
    dispatch({ type: 'RESET' })
  }
})

export default connect(
  undefined,
  mapDispatchToProps
)(ResetButton)
